import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import s from './BoardHeader.module.css';
import sg from '../../../styles/index.module.css';
import { changeFilterValue } from '../../store/slices/filterSlice';
import { setNeedUpdateTotalInfo } from '../../store/slices/totalInfoSlice';

export function BoardHeader() {
    const [searchValue, setSearchValue] = useState('');
    const [isSearchMode, setIsSearchMode] = useState(false);
    const [totalInfo, setTotalInfo] = useState(null);
    const dispatch = useDispatch();
    const pluralizeWords = [
        i18next.t('BoardHeader.return.position'),
        i18next.t('BoardHeader.return.position_genitive'),
        i18next.t('BoardHeader.return.positions')
    ];
    const loadTotalInfo = () => {
        const url = helpable.replaceUrlParameters(routable.getRoute('getTotalInfo'));
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
        })
            .then((response) => response.json())
            .then((data) => {
                setTotalInfo(data.response);
                dispatch(setNeedUpdateTotalInfo(false));
            });
    };
    const needUpdateTotalInfo = useSelector((state) => state.totalInfo);

    const downloadUrl = routable.getRoute('exportEquipment');

    useEffect(() => {
        if (needUpdateTotalInfo) {
            loadTotalInfo();
        }
    }, [needUpdateTotalInfo]);

    return (
        <div className={s.boardHeader}>
            <h2 className={s.boardHeaderTitle}>
                { i18next.t('BoardHeader.return.title') }
            </h2>
            {!isSearchMode && (
                <div className={s.statisticsWrapper}>
                    <div
                        className={s.boardHeaderSearch}
                        onClick={() => {
                            setIsSearchMode(true);
                        }}
                    />
                    <a href={downloadUrl} target="_blank" rel="noreferrer">
                        <div className={s.downloadIcon} />
                    </a>
                    {totalInfo && (
                        <p className={s.statistics}>
                            <span data-id="inventory-count">{totalInfo.inventory_count}</span>
                            <span>
                                {` ${helpable.pluralizeWord(
                                    totalInfo.inventory_count,
                                    pluralizeWords
                                )}`} { i18next.t('BoardHeader.return.for_the_amount') }
                            </span>
                            <span data-id="total-inventory-cost">
                                {` ${numberFormatter.formatMoney(
                                    totalInfo.total_inventory_cost,
                                    2,
                                    totalInfo.currency.sign
                                )} `}
                            </span>
                            <span className={s.separator} />
                            {/* &nbsp;&nbsp;|&nbsp;&nbsp; */}
                            { i18next.t('BoardHeader.return.written_off') }
                            <span data-id="decommissioned-inventory-count">
                                {' '}
                                {totalInfo.decommissioned_inventory_count}{' '}
                            </span>
                            <span>
                                {helpable.pluralizeWord(
                                    totalInfo.decommissioned_inventory_count,
                                    pluralizeWords
                                )} { i18next.t('BoardHeader.return.for_the_amount') }
                            </span>
                            <span data-id="decommissioned-inventory-cost">
                                {` ${numberFormatter.formatMoney(
                                    totalInfo.decommissioned_inventory_cost,
                                    2,
                                    totalInfo.currency.sign
                                )} `}
                            </span>
                        </p>
                    )}
                </div>
            )}
            {isSearchMode && (
                <div className={s.inputWrapper}>
                    <input
                        type="search"
                        value={searchValue}
                        className={cx(sg.input, s.input)}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            dispatch(changeFilterValue(e.target.value));
                        }}
                        autoFocus
                        onFocus={(event) => event.target.select()}
                    />
                    <div
                        className={cx(s.crossButton)}
                        onClick={() => {
                            setSearchValue('');
                            setIsSearchMode(false);
                            dispatch(changeFilterValue(''));
                        }}
                    />
                </div>
            )}
        </div>
    );
}
